import React from 'react';
import '../Footer.css';
import { 
  FaEnvelope, 
  FaGlobe, 
  FaPhoneAlt, 
  FaTelegram,   
  FaInstagram, 
  FaYoutube, 
  FaMapMarkerAlt
} from 'react-icons/fa';
import { SiYandexmaps } from 'react-icons/si';

const Footer = () => {
  // Данные для валют (в реальном проекте можно получать через API но пока делю без API)
  const exchangeDate = "07.05.2026";
  const eurRate = "51.79";
  const usdRate = "44.09";
  

  return (
    <footer className="footer">
      <div className="footer-container">

        {/* Шапка сетки (Загаловки колонок) */}
        <div className="footer-grid-header">
          <div className="grid-title">Наши Адреса</div>
          <div className="grid-title">Связаться с нами</div>
          <div className="grid-title">График работы</div>
          <div className="grid-title">Информация</div>
        </div>

        {/* Первый ряд: Шоурум */}
        <div className="footer-grid-row">
          <div className="footer-cell main-address">
            <strong>Шоурум</strong>
            <p>г. Ташкент Мирабадский район, ул. Авлио Ота 128</p>
            <div className="map-links">
              <a href="https://www.google.com/maps/place/%22Premium+Auto%22/@41.2891944,69.280239,18.05z/data=!4m6!3m5!1s0x38ae5e5555a148e7:0xcc4390d552491cbb!8m2!3d41.2888602!4d69.2810554!16s%2Fg%2F11b7qctf9k?entry=ttu&g_ep=EgoyMDI2MDQyOS4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noreferrer"><FaMapMarkerAlt /> Google Maps</a>
              
              <a href="https://yandex.uz/maps/10335/tashkent/?ll=69.280511%2C41.288061&mode=poi&poi%5Bpoint%5D=69.281143%2C41.288914&poi%5Buri%5D=ymapsbm1%3A%2F%2Forg%3Foid%3D108917662981&z=17.4" target="_blank" rel="noreferrer"><FaMapMarkerAlt className="red-icon"/> Yandex Maps</a>
            </div>
          </div>
          <div className="footer-cell contact-info">
            <span className="mobile-only-label">Шоурум</span>
            <a href="tel: +998712958877" className="footer-link bold">
              <FaPhoneAlt className="small-icon" /> + 998 71 295 88 77 
            </a>
          </div>
          <div className="footer-cell schedule-info">
            <p>Понедельник - Воскресенье</p>
            <p className="time">10:00 - 19:00</p>
          </div>
          <div className="footer-cell exchange-info">
            <p className="exchange-date">Курс валют на <strong>07.05.2026</strong></p>
            <p>EUR/USD = <strong>51.79</strong></p>
            <p>USD/USZ = <strong>44.09</strong></p>
          </div>
        </div>
        
        {/* Второй ряд: сервис  */}
        <div className="footer-grid-row">
          <div className="footer-cell main-address">
              <strong>Сервис</strong>
              <p>г. Ташкент Бектемирский район ул. Туёна 10</p>
              <div className="map-links">
                <a href="https://www.google.com/maps/place/BMW+Service+Uzbekistan/@41.2418777,69.3364863,18.36z/data=!4m6!3m5!1s0x38ae5ff69ba3218f:0xe7e213ba5178689c!8m2!3d41.2418345!4d69.3375715!16s%2Fg%2F11mclfxdv2?entry=ttu&g_ep=EgoyMDI2MDQyOS4wIKXMDSoASAFQAw%3D%3D" target="_blank" rel="noreferrer"><FaMapMarkerAlt /> Google Maps</a>
                
                <a href="https://yandex.uz/maps/10335/tashkent/?ll=69.341502%2C41.242621&mode=poi&poi%5Bpoint%5D=69.337550%2C41.242324&poi%5Buri%5D=ymapsbm1%3A%2F%2Forg%3Foid%3D173208040187&z=15.99" target="_blank" rel="noreferrer"><FaMapMarkerAlt className="red-icon"/> Yandex Maps</a>
              </div>
          </div>
          <div className="footer-cell contact-info">
            <span className="mobile-only-label">Сервис</span>
            <a href="tel: +998992958877" className="footer-link bold">
               <FaPhoneAlt className="small-icon" /> +998 99 295 88 77
            </a>
          </div>
          <div className="footer-cell schedule-info">
            <p>Понедельник - Воскресенье</p>
            <p>09:00 - 18:00</p>
          </div>
            <div className="footer-cell nav-links">
            <a href="#">О нас</a>
            <a href="#">Вакансии</a>
          </div>
        </div>

        {/* Тертий ряд: почта, соцсети и навигация  */}
        <div className="footer-grid-bottom">

          <div className="footer-cell">
            {/* Пустая ячейка для сохранения сетки */}
          </div>
          <div className="footer-cell">
            {/* Пустая ячейка для сохранения сетки */}
          </div>
          <div className="footer-cell">
            <a href="mailto:bmw.uz@bmw.uz" className="footer-link email-link">
              <FaEnvelope /> bmw.uz@bmw.uz
            </a>
          </div>
          <div className="footer-cell social-box">
            <span className="social-text">Подписывайтесь на нас</span>
            <div className="social-icons">
              <a href="https://t.me/bmwuzpa"><FaTelegram /></a>
              <a href="https://www.instagram.com/bmwuz/"><FaInstagram /></a>
              <a href="https://youtube.com/your_channel"><FaYoutube /></a>
            </div>
          </div>

        </div>
      </div>
    </footer>
  );
};

export default Footer;